/*eslint-disable */
import axios from "axios";
import { clearTokens, getConfigAutoGuest, getRefreshToken, getTokens, setTokens } from "../base/util/cookies";
import { API_MAP, COOKIES_REFRESH_TOKEN_KEY, LANDING_PAGE, LINK_JITSIMEET, authDomain } from "../../../modules/API/constants_ts";
const axiosClient = axios.create({
    baseURL: authDomain,
    headers: {
        'content-type': 'application/json',
    },
    method: 'GET'
});
export let isRefreshing = false;
export let failedQueue = [];
const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        }
        else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};
axiosClient.interceptors.request.use(async (config) => {
    const token = getTokens().accessToken;
    if (token) {
        config.headers = config.headers;
        config.headers.set('token', token);
        // config.headers = { ...config.headers, token: token } as InternalAxiosRequestConfig['headers'];
    }
    else if (location.href === LINK_JITSIMEET || location.href === LINK_JITSIMEET + '/') {
        location.href = LANDING_PAGE;
    }
    else {
        // GUEST_JOIN
        const { iAmRecorder } = APP.store.getState()['features/base/config'];
        const autoGuest = getConfigAutoGuest();
        if (!iAmRecorder || !autoGuest) {
            // TODO
            // APP.store.dispatch(openLoginDialog());
        }
    }
    return config;
});
function safeParse(str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
}
axiosClient.interceptors.response.use((response) => {
    return response.data;
}, async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
        try {
            const token = await refreshTokenWrapper();
            originalRequest._retry = true;
            axiosClient.defaults.headers.common['token'] = token;
            originalRequest.headers['token'] = token;
            if (originalRequest?.data) {
                originalRequest.data = safeParse(originalRequest?.data);
            }
            return axiosClient(originalRequest);
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    return Promise.reject(error);
});
export const refreshTokenWrapper = async () => {
    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
        })
            .then(token => {
            return token;
        })
            .catch(err => {
            return Promise.reject(err);
        });
    }
    isRefreshing = true;
    let responseToken = null;
    await navigator.locks.request(COOKIES_REFRESH_TOKEN_KEY, async (lock) => {
        try {
            const res = await axios.post(API_MAP.AUTH.REFRESH_TOKEN, { refreshToken: getRefreshToken() });
            const { token, refreshToken } = res.data?.detail;
            setTokens(token, refreshToken);
            processQueue(null, token);
            responseToken = token;
        }
        catch (err) {
            processQueue(err);
            localStorage.removeItem('token');
            localStorage.removeItem('persist:root');
            clearTokens();
            // window.location.href = PAGE_LOGIN + "?domain=" + window.location.href;
            // [NOTE]
            // const { iAmRecorder } = APP.store.getState()['features/base/config'];
            // if (!iAmRecorder) APP.store.dispatch(openLoginDialog());
            responseToken = null;
        }
        finally {
            isRefreshing = false;
        }
    });
    return responseToken;
};
export default axiosClient;
